export const CONTACT_LANGUAGE_CODE = "languageCode";
export const CONTACT_TIMEZONE = "timeZone";
export const CONTACT_ADDRESS_ADDRESS1 = "address1";
export const CONTACT_ADDRESS_ADDRESS2 = "address2";
export const CONTACT_ADDRESS_CITY = "city";
export const CONTACT_ADDRESS_REGION_CODE = "regionCode";
export const CONTACT_ADDRESS_COUNTRY_CODE = "countryCode";
export const CONTACT_ADDRESS_POSTAL_CODE = "postalCode";

export interface IAddressData {
  [CONTACT_LANGUAGE_CODE]?: string;
  [CONTACT_TIMEZONE]?: string;
  [CONTACT_ADDRESS_ADDRESS1]?: string;
  [CONTACT_ADDRESS_ADDRESS2]?: string;
  [CONTACT_ADDRESS_CITY]?: string;
  [CONTACT_ADDRESS_REGION_CODE]?: string;
  [CONTACT_ADDRESS_COUNTRY_CODE]?: string;
  [CONTACT_ADDRESS_POSTAL_CODE]?: string;
}
